import ModernLayout from "./ModernLayout";

export default function PageContainer({ children }: { children: React.ReactNode }) {
  return <ModernLayout>{children}</ModernLayout>;
}
